export enum BlogCategoryEnum {
    ArtificialIntelligence = "Artificial Intelligence",
    Data = "Data",
    // Entrepreneurship = "Entrepreneurship",
    Experience = "Experience",
    SoftwareDevelopment = "Software Development",
    GuestLecture = "Guest Lecture",
    NepalMarket = "Nepal Market"
}

export const BLOG_CATEGORY = [
    BlogCategoryEnum.ArtificialIntelligence,
    BlogCategoryEnum.Data,
    // BlogCategoryEnum.Entrepreneurship,
    BlogCategoryEnum.Experience,
    BlogCategoryEnum.SoftwareDevelopment,
    BlogCategoryEnum.GuestLecture,
    BlogCategoryEnum.NepalMarket
];

export enum BlogTypeEnum {
    ARTICLE = "Article",
    RESEARCH = "Research"
}

export const BLOG_TYPE = [
    BlogTypeEnum.ARTICLE,
    BlogTypeEnum.RESEARCH
]
export const PCPS_OPPORTUNITY_CATEGORY = [
    BlogCategoryEnum.Experience,
    BlogCategoryEnum.GuestLecture
]
export const PCPS_LIFE_CATEGORY = [
    BlogCategoryEnum.Experience
]
export const PCPS_RESEARCH_CATEGORY = [
    BlogCategoryEnum.ArtificialIntelligence,
    BlogCategoryEnum.Data,
    BlogCategoryEnum.SoftwareDevelopment,
    BlogCategoryEnum.NepalMarket
]